import { render } from "./ExerciseTestCase.vue?vue&type=template&id=36cb78b8&ts=true"
import script from "./ExerciseTestCase.vue?vue&type=script&lang=ts"
export * from "./ExerciseTestCase.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__